/* eslint-disable */
// reducers
import {
  TOGGLE_LOADING,
  UNAUTHORIZED_DEAL_ROOM,
  FETCH_DEAL_ROOM_CATEGORY_LIST,
  CREATED_TEMPLATE_ID,
  FETCH_SECTION_ASSET_LIST,
  CREATED_DEAL_ID,
  PUBLISH_STATUS,
  GO_LIVE_STATUS,
  EDIT_SECTION_TITLE_STATUS
} from "../../constants/DealRoomActionTypes";

const initialState = {
  loading: false,
  unauthorizedDealRoomUpload: null,
  createdTemplateID: null,
  dealRoomCategories: [],
  sectionAssetList: [],
  createdDealID: null,
  publishStatus: false,
  goLiveStatus: false,
  sectionTitleStatus: false
};

const dealRoomUploadReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return { ...state, loading: payload };
    case FETCH_DEAL_ROOM_CATEGORY_LIST:
      return { ...state, dealRoomCategories: payload };
    case CREATED_TEMPLATE_ID:
      return { ...state, createdTemplateID: payload };
    case FETCH_SECTION_ASSET_LIST:
      return { ...state, sectionAssetList: payload };
    case CREATED_DEAL_ID:
      // console.log("createdDealID", payload);
      return { ...state, createdDealID: payload };
    case PUBLISH_STATUS:
      return { ...state, publishStatus: payload };
    case UNAUTHORIZED_DEAL_ROOM:
      return { ...state, unauthorizedDealRoomUpload: payload };
    case GO_LIVE_STATUS:
      return { ...state, goLiveStatus: payload };
    case EDIT_SECTION_TITLE_STATUS:
      return { ...state, sectionTitleStatus: payload };
    default:
      return state;
  }
};
export default dealRoomUploadReducer;
